import {isNil} from 'ramda';
import {isString} from 'ramda-adjunct';

import {hasKey} from 'shared/web';

import {getRowCellValue, type RowData} from 'features/eag-grid';

import {SERVICE_ITEMS_GRID_COLUMNS} from '../constants/serviceItemsGridColumns';

/**
 * First assigned mechanic's key from the first row's `assignMechanics` cell — the same
 * default the per-row 'issue' action preselects in the IssueMaterialItems dialog
 * (JobItemsDataGrid / OrderItemsDataGrid read the identical path from their typed rows).
 * Total: returns undefined for empty rows, an absent column, or a mismatched cell shape.
 */
export const getDefaultMechanicId = (rows: RowData[]): string | undefined => {
  const firstRow = rows.at(0);
  if (isNil(firstRow)) {
    return undefined;
  }
  const assignMechanics = getRowCellValue(firstRow, SERVICE_ITEMS_GRID_COLUMNS.assignMechanics);
  const firstMechanic = Array.isArray(assignMechanics) ? assignMechanics[0] : undefined;
  return hasKey(firstMechanic, 'key', isString) ? firstMechanic.key : undefined;
};
